import { useNavigate } from "react-router-dom";

export default function PendingVerificationPageViewModel() {
  const navigate = useNavigate();
  return [navigate];
}
